import { render, staticRenderFns } from "./requerimientos.vue?vue&type=template&id=516f2238&lang=pug&"
import script from "./requerimientos.vue?vue&type=script&lang=js&"
export * from "./requerimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports